/* eslint-disable camelcase */
import toLowerCase from './lowerCase';
/**
 * Returns true if the first argument contains the second argument, both converted to lower case for comparision
 */
export default function stringContains_inLowerCase(hay, needle) {
    if (!hay || !needle || typeof hay !== 'string' || typeof needle !== 'string')
        return false;
    const hay_lc = toLowerCase(hay);
    const needle_lc = toLowerCase(needle);
    if (!hay_lc || !needle_lc)
        return false;
    return hay_lc.includes(needle_lc);
}
